module.exports = __webpack_public_path__ + "img/8.442dc4f6.png";